
  import React from "react"
  import Component from "/home/runner/_work/vetspire/vetspire/developer.vetspire.com/src/templates/layout.js"
  import data from "/home/runner/_work/vetspire/vetspire/developer.vetspire.com/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js